import React, { memo } from 'react';
import { Blok } from '../../../../../../interfaces/Blok.interface';
import ContactMethodFactory from '../ContactMethodFactory/ContactMethodFactory';

interface PhoneBlokProps extends Blok {
  label: string;
  phone_number: string;
}

interface PhoneProps {
  blok: PhoneBlokProps;
}

const Phone: React.FC<PhoneProps> = ({ blok }) => {
  const { label, phone_number } = blok;

  return (
    <ContactMethodFactory
      icon_url={'/svgs/move-specialist-phone-contact-icon.svg'}
      url={`tel:${phone_number}`}
      label={label}
    />
  );
};

export default memo(Phone);
